import axios from "axios";

//get all learning materials
const getAllMedia = async (token) =>{

    const response = await axios.get("https://www.kipmate.com/manage/wp-json/wp/v2/media");

    return response.data

}

const mediaService = { getAllMedia }

export default mediaService;
